import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { mockServices } from '../../services/mockData';

const initialState = {
  services: [],
  loading: false,
  error: null,
};

// Fetch services (mocked)
export const fetchServices = createAsyncThunk(
  'services/fetchServices',
  async (_, { rejectWithValue }) => {
    try {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 500));
      return mockServices;
    } catch (error) {
      return rejectWithValue('Failed to fetch services');
    }
  }
);

const servicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchServices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchServices.fulfilled, (state, action) => {
        state.loading = false;
        state.services = action.payload;
      })
      .addCase(fetchServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = servicesSlice.actions;

export const selectServices = (state) => state.services.services;
export const selectServicesLoading = (state) => state.services.loading;
export const selectServicesError = (state) => state.services.error;

export default servicesSlice.reducer; 